<template>
    <div class="dog-title-box" :style="{marginTop:`${top}rem`}">
        <span>{{title}}</span>
        <img src="@/assets/index/circle-red.webp" alt="" />
    </div>
</template>
<script>
export default {
    props:{
        top:{
            type:Number,
            default:0
        },
        title:{
            type:String,
            default:''
        }
    }
}
</script>
<style lang="scss" scoped>
    .dog-title-box{
        display: inline;
        position: relative;
        z-index: 1;
        font-size: 0.46rem;
        font-family: FZLanTingHeiS-B-GB;
        color: #000000;
        img {
            position: absolute;
            width: 0.37rem;
            height: 0.37rem;
            right: -0.2rem;
            top: -0.04rem;
            z-index: -1;
        }
    }
</style>